<template>
  <div>
    <div
      :class="
        $vuetify.breakpoint.mdAndUp
          ? 'd-flex align-center mb-5'
          : 'mb-5 text-center'
      "
    >
      <div class="re-series-title pr-3 text-h5 font-weight-bold">
        {{ series }}
      </div>
      <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
      <v-chip
        color="red"
        text-color="white"
        :class="$vuetify.breakpoint.mdAndUp ? 'px-10' : 'mt-5 mx-auto'"
      >
        پیشنهاد برای پایه {{ grade }}
      </v-chip>
    </div>
    <v-row>
      <v-col md="5" v-if="right && $vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col
            md="4"
            class="pl-8"
            v-for="(item, i) in bookseries"
            :key="item._id"
            :index="i"
          >
            <v-img
              contain
              :class="
                i === 1 || i === 4
                  ? 're-rounded re-shadow mt-4'
                  : 're-rounded re-shadow'
              "
              elevation="10"
              :src="'https://dl.pirls.ir/app/bookcovers/' + item._id + '.jpg'"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col md="7">
        <v-row class="pt-7">
          <v-col
            md="6"
            :class="
              $vuetify.breakpoint.smAndDown ? 'py-10 pr-5 pl-10' : 'pa-5 pl-10'
            "
            v-for="item in bookseries"
            :key="item._id"
          >
            <v-card class="re-book-box white pa-3" elevation="4">
              <div
                v-if="item.isfree"
                class="re-price-circle free d-flex align-center justify-center"
              >
                <div>رایگان</div>
              </div>
              <div
                v-else-if="hasBook(item._id)"
                class="re-price-circle active d-flex align-center justify-center"
              >
                <div>فعال</div>
              </div>
              <div
                v-else
                class="re-price-circle d-flex flex-column align-center justify-center"
              >
                <number-component :number="item.price"></number-component>
                <small>ریال</small>
              </div>
              <div v-if="$vuetify.breakpoint.smAndDown" class="re-book-img">
                <v-img
                  contain
                  class="re-img-thumb"
                  :src="
                    'https://dl.pirls.ir/app/bookcovers/' + item._id + '.jpg'
                  "
                />
              </div>
              <div class="d-flex align-center">
                <div class="re-num-box ml-3">
                  {{ item.level }}
                </div>
                <h3 class="flex-fill">
                  {{ item.title }}
                </h3>
              </div>
              <v-divider class="mt-3 mb-1" />
              <div class="d-flex align-center pt-2">
                <v-btn
                  depressed
                  small
                  color="success"
                  v-if="item.isfree || hasBook(item._id)"
                  class="dastnevis flex-fill ml-3 justify-start"
                  router
                  :to="`/Book/Get/${item._id}`"
                >
                  <v-icon left> mdi-book-open-page-variant-outline </v-icon
                  >مطالعه کتاب
                </v-btn>
                <v-btn
                  depressed
                  small
                  color="error"
                  v-else
                  class="dastnevis flex-fill ml-3 justify-start"
                  router
                  :to="`/Order/Checkout/${item._id}`"
                >
                  <v-icon left> mdi-cart-plus </v-icon>خرید کتاب
                </v-btn>
                <v-chip
                  class="re-moral px-2 justify-center"
                  label
                  small
                  color="gray"
                >
                  {{ item.moralvalue }}
                </v-chip>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="5" v-if="!right && $vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col
            md="4"
            class="pr-8"
            v-for="(item, i) in bookseries"
            :key="item._id"
            :index="i"
          >
            <v-img
              contain
              :class="
                i === 1 || i === 4
                  ? 're-rounded re-shadow'
                  : 're-rounded re-shadow mt-4'
              "
              elevation="10"
              :src="'https://dl.pirls.ir/app/bookcovers/' + item._id + '.jpg'"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "book-list-component",
  props: {
    series: { type: String, default: "" },
    grade: { type: String, default: "" },
    right: { type: Boolean, default: false }
  },
  data() {
    return {
      books: [],
      user: {}
    };
  },
  computed: {
    bookseries: function () {
      return this.books.filter((i) => i.series === this.$props.series);
    }
  },
  created() {
    this.getBooks();
  },
  methods: {
    getBooks() {
      this.$api.get("/books").then((res) => {
        this.books = res.data.books;
      });
    },
    hasBook(id) {
      const user = this.$store.getters.user;
      if (user) {
        if (
          user.books.find((i) => i.book._id === id) ||
          user.type === "ادمین" ||
          user.type === "تستر" ||
          user.type === "اپراتور"
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
};
</script>

<style scoped>
.re-series-title {
  border-right: 10 px solid #fcb600;
}
.re-book-box {
  position: relative;
  border-radius: 15px;
}
.re-num-box {
  background: #eeeeee;
  border-radius: 2px 20px 2px 2px;
  padding: 5px 15px 5px 10px;
  font-size: 10px;
}
.re-price-circle {
  position: absolute;
  width: 50px;
  height: 50px;
  top: -25px;
  left: -25px;
  border: 2px dashed #ff5670;
  background: #ff7086;
  font-size: 10px;
  padding: 10px;
  color: white;
  border-radius: 50% !important;
}
.free {
  background: #fcb600;
}
.active {
  border: 2px dashed #3cd1a2;
  background: #51d6ac;
}
.re-moral {
  min-width: 125px;
}
.re-img-thumb {
  width: 70px;
  border-radius: 8px;
  position: absolute;
  top: -55px;
  left: 40px;
}
</style>
